import { unTriggeredRuleResult } from '../utils';

/**
 * Rule for handling the case where a custom validation function is provided
 * @param {ValidationRuleParameters}  params
 * @param {string}                    value
 */
export const hasGetErrorRule = (params, value) => {
  if (typeof value === 'string' || value === undefined) {
    return params.getError ? params.getError(params.label, value) : {
      triggered: false,
      validationState: {
        isValid: true
      }
    };
  } else {
    return unTriggeredRuleResult;
  }
};